import * as React from 'react';

import { ButtonProps as ButtonPropsUi, Button as ButtonUi } from '@ttoss/ui';

export type ButtonProps = {
  size?: 'md' | 'lg';
  outlined?: boolean;
} & ButtonPropsUi;

const Button = ({
  children,
  sx,
  size,
  outlined,
  ...buttonProps
}: ButtonProps) => {
  const sxProps = React.useMemo(() => {
    let sx: ButtonPropsUi['sx'] = {
      borderWidth: 0,
      paddingY: size === 'md' ? 5 : 6,
      backgroundColor: 'primary',
      paddingX: [size === 'md' ? 8 : 7],
      boxShadow: 1,
      fontSize: [size === 'md' ? 2 : 3],
      color: 'background',
    };

    if (outlined) {
      sx = {
        ...sx,
        borderWidth: size === 'md' ? 1 : 2,
        backgroundColor: 'transparent',
        boxShadow: 0,
        color: buttonProps.color || 'text',
        borderColor: buttonProps.color || 'text',
      };

      if (buttonProps.disabled) {
        sx = {
          ...sx,
          borderColor: 'muted',
          color: 'muted',
        };
      }
    } else {
      if (buttonProps.disabled) {
        sx = {
          ...sx,
          backgroundColor: 'muted',
          borderColor: 'muted',
        };
      }
    }

    return sx;
  }, [outlined, buttonProps.disabled, size, buttonProps.color]);

  return (
    <ButtonUi
      sx={{
        // paddingY: [6],
        cursor: 'pointer',
        transition: 'opacity 0.3s',
        ':hover': {
          opacity: 0.7,
        },
        borderColor: 'text',
        borderStyle: 'solid',
        borderRadius: 'partial',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'heading',
        ...sxProps,
        ...sx,
      }}
      {...buttonProps}
    >
      {children}
    </ButtonUi>
  );
};

Button.defaultProps = {
  size: 'lg',
} as ButtonProps;

export default Button;
